import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { EditorService } from 'src/app/shared/services/editor.service';
import { ThemingService } from 'src/app/shared/services/theming.service';


@Component({
    selector: 'app-sumo-code',
    templateUrl: './sumo-code.component.html',
    styleUrls: ['./sumo-code.component.scss'],
})

export class SumoCodeComponent implements OnInit {
    uid: string = "";
    codeName: string = "";
    sumoCodes: any[] = [];
    userData: any = {};
    theme: boolean = true;
    constructor(private editorService: EditorService,private themingService:ThemingService, private toastr: ToastrService, private cookieServ: CookieService,private router: Router) { 
        this.themingService.getThemeName().subscribe((res: any) => {
            this.theme = res;
          })
    }


    ngOnInit(): void {
        this.themingService.pingThemeName();
        this.uid = this.cookieServ.get("uid");
        // this.uid = "u-cf1f0bba-de69-11ed-bc06-7738ed7ada70";
        if (!this.uid || !localStorage.getItem('auth_token') ) {
            this.router.navigate([`login`])
        } else {
            this.getUserProfile();
            this.getSumocodes();
        }
      
    }
    getUserProfile() {
        return this.editorService.getUserprofile({ uid: this.uid })
        .subscribe(res => {
            this.userData = res.userDetails[0];
        })

    }
    // getData() {
    //     forkJoin([this.getUserProfile(), this.getSumocodes()]).subscribe(res => {
    //         this.userData = res[0].userDetails[0];
    //         this.sumoCodes = res[1]?.appSumoCode;
    //     })
    // }
    getSumocodes() {
        return this.editorService.applyAppSumoCode({ uid: this.uid, type: "get" })
        .subscribe(res => {
            if(res.appSumoCode) {
                this.sumoCodes = Array.isArray(res.appSumoCode) ? res.appSumoCode : [] ;
            }
            // console.log(this.sumoCodes)
        })
    }
    redeemAppSumoCode() {
        this.editorService.applyAppSumoCode({ uid: this.uid, type: "create",appSumoCode: this.codeName }).subscribe(res => {
            // this.sumoCodes = res.appSumoCode;
            if (!!res && !!res.error) {
                this.toastr.error(res.error);
            }
            if (!!res && !!res.success) {
                this.toastr.success(res.success);
                this.codeName = '';
                // this.getSumocodes();
                this.getUserProfile()
            }
        })
    }
}